<template>
  <v-navigation-drawer
    v-model="drawer"
    @input="closeDrawer"
    right
    app
    temporary
    floating
    :width="400"
  >
    <v-toolbar color="white" flat dense>
      <v-layout row wrap>
        <v-flex xs1 class="text-xs-top">
          <v-btn fab bot small class="k-orange-linear-text" icon flat @click="closeDrawer(false)">
            <v-icon small>fas fa-angle-right</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 class="text-xs-center">
          <div class="headline text-xs-center k-orange-linear-text pt-2">
            <slot name="title"></slot>
          </div>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <component :is="lTile" :rows="rows"></component>
  </v-navigation-drawer>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  props: {
    url: String,
    fields: String,
    lTile: String,
  },
  mounted() {
    EventBus.$on('close', () => {
      this.drawer = false;
    });
    EventBus.$on('openRightDrawer', () => {
      this.drawer = true;
    });
    EventBus.$on('detail', (id, url = null, fields = null) => {
      this.getData(id, url, fields);
    });
  },
  destroyed() {
    EventBus.$off('close');
    EventBus.$off('openRightDrawer');
    EventBus.$off('detail');
  },
  data() {
    return {
      drawer: false,
      rows: [],
    };
  },
  methods: {
    closeDrawer(value) {
      if (!value) {
        EventBus.$emit('close', false);
      }
    },
    getData(id, url = null, fields = null) {
      this.axios.get(`${url || this.url}/${id}?fields=${fields || this.fields}`).then((response) => {
        this.rows = response.data;
        this.drawer = true;
      });
    },
  },
};
</script>

<style scoped>
  aside.navigation-drawer {
    z-index: 205;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/ShowRightDrawer.vue